import { Link } from "react-router-dom";
import "./footer.css";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { EMAIL } from "../../configs/website-information/websiteInfo";
import { useMasterData } from "../../hooks/useMasterData";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { masterData } = useMasterData();

  return (
    <footer className="site-footer">
      {/* ── Main content ─────────────────────────────── */}
      <div className="site-footer__main">
        <div className="container">
          <div className="maximum-width mx-auto">
            <div className="row g-4 g-lg-5">

              {/* Brand Column */}
              <div className="col-lg-3 col-md-12">
                <Link to="/">
                  {masterData?.LogoUrl
                    ? <img src={masterData.LogoUrl} alt="AdsOne" className="footer-logo" />
                    : <span className="footer-brand">Ads<span className="footer-brand-accent">One</span></span>
                  }
                </Link>
                <p className="footer-tagline">The Largest Marketplace in Sri Lanka</p>
                <p className="footer-description">
                  Buy and sell vehicles with confidence. Thousands of verified listings
                  across Sri Lanka — cars, vans, lorries, motorcycles and more.
                </p>
                <div className="footer-social-row">
                  <a href="#" className="footer-social-link" aria-label="Facebook">
                    <FaFacebook size={16} />
                  </a>
                  <a href="#" className="footer-social-link" aria-label="Instagram">
                    <FaInstagram size={16} />
                  </a>
                  <a href="#" className="footer-social-link" aria-label="Twitter">
                    <FaTwitter size={16} />
                  </a>
                  <a href="#" className="footer-social-link" aria-label="YouTube">
                    <FaYoutube size={16} />
                  </a>
                </div>
              </div>

              {/* More from AdsOne */}
              <div className="col-lg-2 col-md-3 col-6">
                <h6 className="footer-heading">More from AdsOne</h6>
                <ul className="footer-link-list">
                  <li><Link to="/sell-fast">Sell Fast</Link></li>
                  <li><Link to="/membership">Membership</Link></li>
                  <li><Link to="/banner-ads">Banner Ads</Link></li>
                  <li><Link to="/boost-ad">Boost Your Ad</Link></li>
                </ul>
              </div>

              {/* Help & Support */}
              <div className="col-lg-2 col-md-3 col-6">
                <h6 className="footer-heading">Help &amp; Support</h6>
                <ul className="footer-link-list">
                  <li><Link to="/faq">FAQ</Link></li>
                  <li><Link to="/safety-tips">Safety Tips</Link></li>
                  <li><Link to="/contact-us">Contact Us</Link></li>
                </ul>
              </div>

              {/* About AdsOne */}
              <div className="col-lg-2 col-md-3 col-6">
                <h6 className="footer-heading">About AdsOne</h6>
                <ul className="footer-link-list">
                  <li><Link to="/about-us">About Us</Link></li>
                  <li><Link to="/terms">Terms &amp; Conditions</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/sitemap">Sitemap</Link></li>
                </ul>
              </div>

              {/* Contact Details */}
              <div className="col-lg-3 col-md-6 col-12">
                <h6 className="footer-heading">Contact Us</h6>
                <ul className="footer-link-list">
                  <li>
                    <a href={`mailto:${EMAIL}`}>
                      <MdEmail size={14} /> {EMAIL}
                    </a>
                  </li>
                </ul>
                <div className="mt-3" style={{ fontSize: "0.8rem", color: "#6b7280" }}>
                  Mon – Fri: 9am – 6pm<br />
                  Sat – Sun: 8am – 5pm
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom bar ───────────────────────────────── */}
      <div className="site-footer__bottom">
        <div className="container">
          <div className="maximum-width mx-auto d-flex justify-content-between align-items-center flex-wrap gap-2 px-1">
            <span>© {currentYear} AdsOne. All rights reserved.</span>
            <span>Made with ❤️ in Sri Lanka</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
